import type { StorePromotionalAdWithPreview } from '@dukanti/shared';

export function orderPromotionalAdsForDisplay(
  sourceAds: readonly StorePromotionalAdWithPreview[],
  pendingOrderIds: readonly string[] | null,
): StorePromotionalAdWithPreview[] {
  const sortedAds = [...sourceAds].sort((a, b) => a.display_order - b.display_order);
  if (!pendingOrderIds) return sortedAds;

  const rankById = new Map(pendingOrderIds.map((id, index) => [id, index]));
  return sortedAds.sort((a, b) => {
    const aRank = rankById.get(a.id);
    const bRank = rankById.get(b.id);
    if (aRank !== undefined && bRank !== undefined) return aRank - bRank;
    if (aRank !== undefined) return -1;
    if (bRank !== undefined) return 1;
    return a.display_order - b.display_order;
  });
}
